// SceneItemMenu.tsx
import { Box, Divider, Menu, MenuItem, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./SceneItemMenu.module.scss";
interface IMenuItem {
	label: string;
	icon: string;
	onClick: () => void;
}

interface SceneItemMenuProps {
	anchorEl: HTMLElement | null;
	onClose: (e: React.MouseEvent<any>) => void;
	menuItems: IMenuItem[];
	sceneName: string;
	width?: number;
	height?: number;
	setIsHovered: (hovered: boolean) => void;
	isMainScene?: boolean;
}

const SceneItemMenu: React.FC<SceneItemMenuProps> = ({
	anchorEl,
	onClose,
	menuItems,
	sceneName,
	width,
	height,
	setIsHovered,
	isMainScene,
}) => {
	const { t } = useTranslation("translation", { keyPrefix: "campaignTab.scenes" });

	return (
		<Menu
			onClick={(e) => e.stopPropagation()}
			classes={{ paper: styles.paper }}
			anchorEl={anchorEl}
			open={Boolean(anchorEl)}
			onClose={onClose}
			MenuListProps={{
				onMouseEnter: () => setIsHovered(true),
				onMouseLeave: () => !anchorEl && setIsHovered(false),
			}}
			anchorOrigin={{
				vertical: "top",
				horizontal: "left",
			}}
			transformOrigin={{
				vertical: "bottom",
				horizontal: "left",
			}}
		>
			<Typography className={styles.sceneName}>{sceneName}</Typography>
			<Typography className={styles.sceneName}>{`${width}x${height}`}</Typography>
			<Divider className={styles.divider} />
			<Box>
				{menuItems.map((item, index) => (
					<MenuItem
						key={index}
						onClick={(e) => {
							e.stopPropagation();
							item.onClick();
							onClose(e);
						}}
						classes={{ root: styles.menuItemRoot }}
						className={clsx({
							[styles.disabled]: isMainScene && item.label === t("setAsMainScene"),
						})}
					>
						<Box className={styles.menuIconWrapper}>
							<img src={item.icon} />
							<Typography className={styles.menuLabel}>{item.label}</Typography>
						</Box>
					</MenuItem>
				))}
			</Box>
		</Menu>
	);
};

export default SceneItemMenu;
